export * from "@/ui/components/layout/Main/Main";
export * from "@/ui/components/layout/Main/Main.config";
